import { ArrowRight, ChevronDown } from "lucide-react";
import React, { PropsWithChildren } from "react";
import { Button, ButtonProps } from "./button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./dropdown-menu";

export type MultiButtonProps = {
  label?: string;
  variant?: ButtonProps["variant"];
};

type MultiButtonItemProps = {
  icon?: React.ReactNode;
  label: string;
  description?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

export function MultiButtonSeparator() {
  return <DropdownMenuSeparator />;
}

export function MultiButtonItem({
  icon,
  label,
  description,
  onClick,
  children,
}: MultiButtonItemProps) {
  return (
    <DropdownMenuItem aria-label={label} onClick={onClick} className="p-2">
      {icon}
      <div className="flex flex-col flex-1">
        <span className="text-sm">{label}</span>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
      {children}
      <ArrowRight className="text-muted-foreground" size={10} />
    </DropdownMenuItem>
  );
}

export function MultiButton({
  children,
  label,
  variant,
}: PropsWithChildren<MultiButtonProps>) {
  return (
    <div className="flex items-center">
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant={variant} size={label ? "default" : "icon"}>
            {label}
            <ChevronDown />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[300px]">
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
